<template>
    <component ref="root" :is="componentType" @loader="loaderHandler" v-bind="dataProps"></component>
</template>

<script lang="ts" setup>
import { computed, markRaw, onMounted, ref, watch, defineAsyncComponent } from "vue";
import { AppRootEnum } from "./app-root-enum";
const loadingClass = "section-loading";

const props = withDefaults(
    defineProps<{
        componentName: string;
        showLoader: boolean;
        dataProps: object;
        appRoot: AppRootEnum;
    }>(),
    {
        showLoader: true,
        isStandalone: false,
    }
);

const root = ref(null);

const loader = ref(props.showLoader);

const componentDestinationPath = computed(() => {
    return props.componentName.substr(0, props.componentName.lastIndexOf("/"));
});

const componentName = computed(() => {
    return props.componentName.split("/").slice(-1)?.[0];
});

const getComponentPath = () => {
    switch (props.appRoot) {
        case AppRootEnum.sharedComponents:
            return import(
                `../../../../libs/shared-components/${componentDestinationPath.value}/_${componentName.value}.vue`
            );
        default:
            return import(`../app/${componentDestinationPath.value}/${componentName.value}.vue`);
    }
};

const componentType = markRaw(defineAsyncComponent(() => getComponentPath()));
function handleLoaderChange() {
    if (!root.value) {
        return;
    }

    const parent = root.value.$parent.$el;

    if (!loader.value && parent.classList.contains(loadingClass)) {
        parent.classList.remove(loadingClass);
    } else if (loader.value && !parent.classList.contains(loadingClass)) {
        parent.classList.add(loadingClass);
    }
}

const loaderHandler = (value: boolean) => {
    loader.value = value;
};

watch(loader, () => {
    handleLoaderChange();
});

onMounted(() => {
    handleLoaderChange();
});
</script>
